import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
// import { WebSocketProvider } from './contexts/WebSocketContext';
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import BOLPage from './pages/BOLPage'
import BOLDetailPage from './pages/BOLDetailPage'
import ProfilePage from './pages/ProfilePage'

function App() {
  return (
    <AuthProvider>
      {/* <WebSocketProvider> */}
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>              <Route index element={<Navigate to="/bol" replace />} />
              <Route path="bol" element={<BOLPage />} />
              <Route path="bol/:id" element={<BOLDetailPage />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
            
            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/bol" replace />} />
          </Routes>
        </div>
      {/* </WebSocketProvider> */}
    </AuthProvider>
  )
}

export default App 